var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.item.pledgeUpdatedData.amount
        ? _c(
            "layoutText",
            { attrs: { fontSize: 1, color: "#333", "font-weight": "bold" } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.formatMoney(_vm.item.pledgeUpdatedData.amount)) +
                  " "
              )
            ]
          )
        : _vm._e(),
      _vm.item.pledgeUpdatedData.uncollectible === true
        ? _c(
            "layoutText",
            { attrs: { fontSize: 1, color: "#333", "font-weight": "bold" } },
            [_vm._v("Marked as uncollectible")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }